/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  FetchCommunityFinancialsResponse,
  FetchCommunityFinancialsResponseFromJSON,
  FetchDirectorFinancialDetailsResponse,
  FetchDirectorFinancialDetailsResponseFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface FetchCommunityFinancialsRequest
  extends runtime.BaseRequestParameters {
  communityKey: number
  academicYear: number
}

export interface FetchDirectorFinancialDetailsRequest
  extends runtime.BaseRequestParameters {
  communityKey: number
  actorKey: number
}

/**
 * FinancialsApi - interface
 *
 * @export
 * @interface FinancialsApiInterface
 */
export interface FinancialsApiInterface {
  /**
   * Fetch financial information for a community
   * @summary Fetch financial information for a community
   * @param {number} communityKey The unique identifier for the community, to which the financial information pertains.
   * @param {number} academicYear The year of the academic year for which financial information is requested.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FinancialsApiInterface
   */
  fetchCommunityFinancialsRaw(
    requestParameters: FetchCommunityFinancialsRequest
  ): Promise<runtime.ApiResponse<FetchCommunityFinancialsResponse>>

  /**
   * Fetch financial information for a community
   * Fetch financial information for a community
   */
  fetchCommunityFinancials(
    requestParameters: FetchCommunityFinancialsRequest
  ): Promise<FetchCommunityFinancialsResponse>

  /**
   * Fetch financial information for a director, including amounts owed by tutors and families.
   * @summary Fetch financial information for a director, including amounts owed by tutors and families.
   * @param {number} communityKey The unique identifier for the community, to which the director\&#39;s financial information pertains.
   * @param {number} actorKey The unique identifier for the director whose financial details are being requested.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FinancialsApiInterface
   */
  fetchDirectorFinancialDetailsRaw(
    requestParameters: FetchDirectorFinancialDetailsRequest
  ): Promise<runtime.ApiResponse<FetchDirectorFinancialDetailsResponse>>

  /**
   * Fetch financial information for a director, including amounts owed by tutors and families.
   * Fetch financial information for a director, including amounts owed by tutors and families.
   */
  fetchDirectorFinancialDetails(
    requestParameters: FetchDirectorFinancialDetailsRequest
  ): Promise<FetchDirectorFinancialDetailsResponse>
}

/**
 *
 */
export class FinancialsApi
  extends runtime.BaseAPI
  implements FinancialsApiInterface
{
  /**
   * Fetch financial information for a community
   * Fetch financial information for a community
   */
  async fetchCommunityFinancialsRaw(
    requestParameters: FetchCommunityFinancialsRequest
  ): Promise<runtime.ApiResponse<FetchCommunityFinancialsResponse>> {
    if (
      requestParameters.communityKey === null ||
      requestParameters.communityKey === undefined
    ) {
      throw new runtime.RequiredError(
        'communityKey',
        'Required parameter requestParameters.communityKey was null or undefined when calling fetchCommunityFinancials.'
      )
    }

    if (
      requestParameters.academicYear === null ||
      requestParameters.academicYear === undefined
    ) {
      throw new runtime.RequiredError(
        'academicYear',
        'Required parameter requestParameters.academicYear was null or undefined when calling fetchCommunityFinancials.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.communityKey !== undefined) {
      queryParameters['communityKey'] = requestParameters.communityKey
    }

    if (requestParameters.academicYear !== undefined) {
      queryParameters['academicYear'] = requestParameters.academicYear
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/financials`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchCommunityFinancialsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetch financial information for a community
   * Fetch financial information for a community
   */
  async fetchCommunityFinancials(
    requestParameters: FetchCommunityFinancialsRequest
  ): Promise<FetchCommunityFinancialsResponse> {
    const response = await this.fetchCommunityFinancialsRaw(requestParameters)
    return await response.value()
  }

  /**
   * Fetch financial information for a director, including amounts owed by tutors and families.
   * Fetch financial information for a director, including amounts owed by tutors and families.
   */
  async fetchDirectorFinancialDetailsRaw(
    requestParameters: FetchDirectorFinancialDetailsRequest
  ): Promise<runtime.ApiResponse<FetchDirectorFinancialDetailsResponse>> {
    if (
      requestParameters.communityKey === null ||
      requestParameters.communityKey === undefined
    ) {
      throw new runtime.RequiredError(
        'communityKey',
        'Required parameter requestParameters.communityKey was null or undefined when calling fetchDirectorFinancialDetails.'
      )
    }

    if (
      requestParameters.actorKey === null ||
      requestParameters.actorKey === undefined
    ) {
      throw new runtime.RequiredError(
        'actorKey',
        'Required parameter requestParameters.actorKey was null or undefined when calling fetchDirectorFinancialDetails.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.communityKey !== undefined) {
      queryParameters['communityKey'] = requestParameters.communityKey
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/financials/directorDetails`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchDirectorFinancialDetailsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Fetch financial information for a director, including amounts owed by tutors and families.
   * Fetch financial information for a director, including amounts owed by tutors and families.
   */
  async fetchDirectorFinancialDetails(
    requestParameters: FetchDirectorFinancialDetailsRequest
  ): Promise<FetchDirectorFinancialDetailsResponse> {
    const response = await this.fetchDirectorFinancialDetailsRaw(
      requestParameters
    )
    return await response.value()
  }
}
